import { render, staticRenderFns } from "./DialogViewTransfer.vue?vue&type=template&id=7236b6c9"
import script from "./DialogViewTransfer.js?vue&type=script&lang=js&external"
export * from "./DialogViewTransfer.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports